
  import Themeable from 'vuetify/lib/mixins/themeable'
  import HasScope from '@/components/Mixins/HasScope'
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { Item as ItemInterface } from '@/views/interfaces/vuetify/item.interface'

  @Component({
    mixins: [
      Themeable,
      HasScope,
    ],
  })
  export default class Item extends Vue {
    [x: string]: any;

    @Prop({ type: String, default: '' }) private readonly scope!: string
    @Prop({
      type: Object, default: () => ({
        href: undefined,
        icon: undefined,
        subtitle: undefined,
        title: undefined,
        to: undefined,
      }),
    }) private readonly item!: ItemInterface
    @Prop({ type: Boolean, default: false }) private readonly text!: boolean
    @Prop({ type: String, default: '' }) private readonly icon!: string
    @Prop({ type: String, default: 'large' }) private readonly iconSize!: string

    get computedText(): string {
      if (!this.item.title) {
        return ''
      }

      let text = ''

      this.item.title.split(' ').forEach((val: string) => {
        text += val.substring(0, 1)
      })

      return text
    }

    get href(): string | undefined {
      return this.item.href || (!this.item.to ? '#' : undefined)
    }

    get route(): string {
      if (this.item.toFixed) {
        return this.item.toFixed
      } else if (this.item.to) {
        return this.item.to
      }

      return ''
    }

    get isActive(): string {
      if (this.item.toFixed !== undefined) {
        return `${this.$route.path === this.item.toFixed ? 'primary ' : ' '}${!this.isDark ? 'black' : 'white'}--text`;
      } else {
        return `${this.$route.path === this.item.to ? 'primary ' : ' '}${!this.isDark ? 'black' : 'white'}--text`;
      }
    }
  }
